import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import { Badge } from 'primereact/badge';
import axios from "axios";
import moment from "moment/moment";

const PayrollexportListComponent = (props) => {

  const {t} = props;
  const [payrollexports, setPayrollexports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [statusDict, setStatusDict] = useState({});
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const loadLazyData = () => {
    setLoading(true);
    const endpoint = props.type === 'daily' 
      ? '/api/v2/export/daily_work_summary' 
      : '/api/v2/export/monthly_work_summary';
    apiCall('get', endpoint + window.App.transformQueryParams(lazyParams))
    .then(response => {
      setTotalRecords(response.data.data.total_item_count);
      setPayrollexports(response.data.data.items);
    })
    .catch(error => window.App.toastShow('error', t('error'), error.toString()))
    .finally(() => setLoading(false));
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const downloadFile = (fileId) => {
    setLoading(true);
    apiCall('get', `/api/v2/file/${fileId}/download`, {}, 'blob')
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `export_${props.type}_${moment().format('YYYYMMDD_HHmm')}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), 'Sikertelen letöltés');
      })
      .finally(() => setLoading(false));
  };

  const actionBodyTemplate = (rowData) => {
    const fileId = rowData.file_id || rowData.file?.id;
    return (
      <React.Fragment>
        {fileId && (
        <Button icon="pi pi-download" className="p-button-info" 
                onClick={() => downloadFile(fileId)} tooltip={t('download')} />
      )}
        {/* {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'payroll') {
                      history.push('/inventory/tmp/update/' + rowData.id)
                    }
                  }}/>
        } */}
        {/* {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/tmp/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderTmpList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        } */}
      </React.Fragment>
    );
  }

  const loadStatusDict = () => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/v2/dictionary/export-status", {
      params: { _ts: Date.now() }
    })
      .then(response => {
        const data = response?.data?.data;
        if (Array.isArray(data)) {
          const dict = data.reduce((acc, it) => {
            if (it?.key != null && it?.value != null) {
              acc[String(it.key)] = String(it.value);
              acc[String(it.key).toLowerCase()] = String(it.value);
            }
            return acc;
          }, {});
          setStatusDict(dict);
          return;
        }
        if (data && typeof data === 'object') {
          setStatusDict(data);
          return;
        }
        setStatusDict({});
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setStatusDict({});
      });
  };

  const statusLabel = (status) => {
    if (!status) return '';
    const s = String(status);
    return statusDict?.[s] ?? statusDict?.[s.toLowerCase()] ?? s;
  };

  const getStatusSeverity = (statusRaw) => {
    const s = (statusRaw ?? '').toString().trim().toLowerCase();
    if (s === 'done') return 'success';
    if (s === 'processing') return 'info';
    if (s === 'pending') return 'warning';
    return 'danger';
  };

  useEffect(() => {
    loadStatusDict();
  }, []);

  useEffect(() => {
    const refresh = () => {
      loadStatusDict();
      loadLazyData();
    };
    window.addEventListener('payrollexportListRefresh', refresh);
    return () => window.removeEventListener('payrollexportListRefresh', refresh);
  }, [props.type]);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderPayrollexportList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={payrollexports} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="status" header={t('columnStatus2')} sortable filter body={(rowData) => <Badge value={statusLabel(rowData.status)} severity={getStatusSeverity(rowData.status)} />}></Column>
        <Column field="processed_rows" header={t('columnProcessedRows')} sortable></Column>
        <Column field="total_rows" header={t('columnTotalRows')} sortable></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(PayrollexportListComponent);
